import { create } from './BaseService';

const http = create();

export const createUser = (user) => {
  return http.post('/new-user', user);
};

export const updateUser = (user) => {
  return http.post('/update-user', user);
};

export const updateUserSettings = (setting) => {
  return http.post('/update-user/settings', { setting });
};

export const updateUserCards = (cards) => {
  return http.post('/update-user/cards', { cards });
};

export const getCurrentUser = () => {
  return http.get('/users/me');
};

export const getSection = () => {
  return http.get('/section');
};

export const forgotPassword = (email) => {
  return http.post('/auth/forgot-password', { email });
};

export const validateResetToken = (token) => {
  return http.get(`/auth/validate-reset-token/${token}`);
};

export const resetPassword = (token, password) => {
  return http.post('/auth/reset-password', { token, password });
};
